import { StepConnector as MUIStepConnector } from '@mui/material'
import { withStyles } from 'tss-react/mui'

const StepConnector = withStyles(MUIStepConnector, (_theme, _params, classes) => ({
  alternativeLabel: {
    top: 6,
    left: '-50%',
    right: '50%',
  },
  active: {
    [`& .${classes.line}`]: {
      borderColor: '#FFF2DC',
    },
  },
  completed: {
    [`& .${classes.line}`]: {
      borderColor: '#FFF2DC',
    },
  },
  line: {
    borderColor: '#EDEDED',
    borderTopWidth: 10,
  },
}))

export default StepConnector
